// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"271":"5fa69c71","974":"d8dc19ee"}[chunkId] + ".chunk.css";
};